import React, { useState, useEffect, useRef } from "react";
import "./Header.css";
import {
  FaSearch,
  FaHome,
  FaHeart,
  FaBell,
  FaBullhorn,
  FaWallet,
  FaTimes,
  FaNewspaper,
  FaList,
  FaStore,
  FaRocket,
  FaBuilding,
  FaCalendarAlt,
  FaCog,
  FaUser,
  FaListAlt,
  FaQuestionCircle,
  FaFileAlt,
  FaSignOutAlt,
  FaInfoCircle,
  FaShieldAlt,
  FaBan,
  FaUserPlus,
  FaCalendarDay,
  FaChevronRight,
  FaGlobe,
  FaBalanceScale,
  FaBaby,
} from "react-icons/fa";
import WalletModal from "./WalletModal";
import { fetchNotifications, API_BASE_URL } from "../services/api";
import { playSound } from "../services/sounds";

const HomeIcon = ({ active }) => (
  <svg
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: "block", transition: "all 0.3s ease" }}
  >
    <defs>
      <linearGradient id="homeGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor={active ? "#38bdf8" : "#94a3b8"} />
        <stop offset="100%" stopColor={active ? "#0ea5e9" : "#64748b"} />
      </linearGradient>
    </defs>
    <path
      d="M12 3L2 12h3v8a1 1 0 001 1h12a1 1 0 001-1v-8h3L12 3z"
      fill="url(#homeGrad)"
      style={{ transition: "all 0.3s ease" }}
    />
    <path
      d="M10 21v-6a2 2 0 014 0v6"
      stroke={active ? "#ffffff" : "#475569"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ transition: "all 0.3s ease" }}
    />
  </svg>
);

const DiscoverIcon = ({ active }) => (
  <svg
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: "block", transition: "all 0.3s ease" }}
  >
    <defs>
      <linearGradient id="discoverGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor={active ? "#38bdf8" : "#94a3b8"} />
        <stop offset="100%" stopColor={active ? "#0ea5e9" : "#64748b"} />
      </linearGradient>
    </defs>
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke="url(#discoverGrad)"
      strokeWidth="2"
      fill={active ? "rgba(14, 165, 233, 0.15)" : "none"}
      style={{ transition: "all 0.3s ease" }}
    />
    <polygon
      points="16.24,7.76 14.12,14.12 7.76,16.24 9.88,9.88"
      fill="url(#discoverGrad)"
      style={{ transition: "all 0.3s ease" }}
    />
    <circle
      cx="12"
      cy="12"
      r="1.5"
      fill={active ? "#ffffff" : "#64748b"}
    />
  </svg>
);

const PropertyIcon = ({ active }) => (
  <svg
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: "block", transition: "all 0.3s ease" }}
  >
    <defs>
      <linearGradient id="propertyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor={active ? "#38bdf8" : "#94a3b8"} />
        <stop offset="100%" stopColor={active ? "#0ea5e9" : "#64748b"} />
      </linearGradient>
    </defs>
    {/* House Structure */}
    <path
      d="M2 10.5L9.5 4L15 8.8V20H4a1 1 0 01-1-1v-8.5z"
      fill="url(#propertyGrad)"
      opacity={active ? "1" : "0.85"}
      style={{ transition: "all 0.3s ease" }}
    />
    {/* Highrise building adjacent */}
    <path
      d="M13 6.5V20H21a1 1 0 001-1V8.5a1 1 0 00-.4-.8l-4.5-3.6a1 1 0 00-1.2 0L13 6.5z"
      fill="url(#propertyGrad)"
      opacity={active ? "0.8" : "0.65"}
      style={{ transition: "all 0.3s ease" }}
    />
    {/* House Door & Windows */}
    <rect x="6.5" y="14" width="3" height="6" rx="0.5" fill={active ? "#ffffff" : "rgba(255,255,255,0.4)"} />
    <rect x="16" y="9" width="2" height="2" rx="0.5" fill={active ? "#ffffff" : "rgba(255,255,255,0.4)"} />
    <rect x="16" y="13" width="2" height="2" rx="0.5" fill={active ? "#ffffff" : "rgba(255,255,255,0.4)"} />
    <rect x="16" y="17" width="2" height="2" rx="0.5" fill={active ? "#ffffff" : "rgba(255,255,255,0.4)"} />
  </svg>
);

const SlotifyIcon = ({ active }) => (
  <svg
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: "block", transition: "all 0.3s ease" }}
  >
    <defs>
      <linearGradient id="slotifyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor={active ? "#38bdf8" : "#94a3b8"} />
        <stop offset="100%" stopColor={active ? "#0ea5e9" : "#64748b"} />
      </linearGradient>
    </defs>
    <rect
      x="3"
      y="5"
      width="18"
      height="16"
      rx="2"
      fill="url(#slotifyGrad)"
      style={{ transition: "all 0.3s ease" }}
    />
    <path d="M3 10h18" stroke={active ? "#ffffff" : "#334155"} strokeWidth="1.5" />
    <rect x="6" y="3" width="2" height="4" rx="1" fill={active ? "#ffffff" : "#475569"} />
    <rect x="16" y="3" width="2" height="4" rx="1" fill={active ? "#ffffff" : "#475569"} />
    <circle
      cx="12"
      cy="15"
      r="3"
      fill={active ? "rgba(255,255,255,0.9)" : "rgba(255,255,255,0.3)"}
      style={{ transition: "all 0.3s ease" }}
    />
    <path
      d="M12 13.5v1.5l1 1"
      stroke={active ? "#0ea5e9" : "#64748b"}
      strokeWidth="1"
      strokeLinecap="round"
    />
  </svg>
);

const RocketIcon = ({ active }) => (
  <svg
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: "inline-block", transition: "all 0.3s ease", marginRight: "6px" }}
  >
    <defs>
      <linearGradient id="rocketGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fbbf24" />
        <stop offset="100%" stopColor="#d97706" />
      </linearGradient>
    </defs>
    <path
      d="M4.5 16.5c-1.5 1.5-2.5 3.5-2.5 3.5s2-1 3.5-2.5m4.5-8.5l-6 6m8-8c1.5-1.5 4.5-2 6-2s.5 4.5-1 6l-9 9-4.5-4.5 9-9z"
      stroke="url(#rocketGrad)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 15c-.5.5-1.5.5-2 0s-.5-1.5 0-2"
      stroke="url(#rocketGrad)"
      strokeWidth="2"
    />
  </svg>
);

const HeartIcon = ({ active }) => (
  <svg
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: "block", transition: "all 0.3s ease" }}
  >
    <defs>
      <linearGradient id="heartGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#f43f5e" />
        <stop offset="100%" stopColor="#e11d48" />
      </linearGradient>
    </defs>
    <path
      d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
      fill={active ? "url(#heartGrad)" : "none"}
      stroke={active ? "none" : "currentColor"}
      strokeWidth="2"
      style={{ transition: "all 0.3s ease" }}
    />
  </svg>
);

const BellIcon = ({ active }) => (
  <svg
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: "block", transition: "all 0.3s ease" }}
  >
    <defs>
      <linearGradient id="bellGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fbbf24" />
        <stop offset="100%" stopColor="#d97706" />
      </linearGradient>
    </defs>
    <path
      d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9zm-4.27 13a1.996 1.996 0 01-3.46 0"
      fill={active ? "url(#bellGrad)" : "none"}
      stroke={active ? "none" : "currentColor"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ transition: "all 0.3s ease" }}
    />
  </svg>
);

const CogIcon = ({ active }) => (
  <svg
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="cog-icon-svg"
    style={{ display: "block", transition: "all 0.3s ease" }}
  >
    <defs>
      <linearGradient id="cogGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#c084fc" />
        <stop offset="100%" stopColor="#8b5cf6" />
      </linearGradient>
    </defs>
    <path
      d="M12.22 2h-.44a2 2 0 00-2 2v.18a2 2 0 01-1 1.73l-.43.25a2 2 0 01-2 0l-.15-.08a2 2 0 00-2.73.73l-.22.38a2 2 0 00.73 2.73l.15.1a2 2 0 011 1.72v.51a2 2 0 01-1 1.74l-.15.09a2 2 0 00-.73 2.73l.22.38a2 2 0 002.73.73l.15-.08a2 2 0 012 0l.43.25a2 2 0 011 1.73V20a2 2 0 002 2h.44a2 2 0 002-2v-.18a2 2 0 011-1.73l.43-.25a2 2 0 012 0l.15.08a2 2 0 002.73-.73l.22-.39a2 2 0 00-.73-2.73l-.15-.08a2 2 0 01-1-1.74v-.5a2 2 0 011-1.74l.15-.1a2 2 0 00.73-2.73l-.22-.38a2 2 0 00-2.73-.73l-.15.08a2 2 0 01-2 0l-.43-.25a2 2 0 01-1-1.73V4a2 2 0 00-2-2z"
      fill={active ? "url(#cogGrad)" : "none"}
      stroke={active ? "none" : "currentColor"}
      strokeWidth="2"
      style={{ transition: "all 0.3s ease" }}
    />
    <circle cx="12" cy="12" r="3" stroke={active ? "#ffffff" : "currentColor"} strokeWidth="2" />
  </svg>
);

const Header = React.memo(
  ({ onSearch, isSearching, currentView, onNavigate, user, onRefresh }) => {
    const [searchQuery, setSearchQuery] = useState("");
    const [showWalletModal, setShowWalletModal] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [touristMode, setTouristMode] = useState(false);

    // Notifications State
    const [notifications, setNotifications] = useState([]);
    const notificationsRef = useRef([]);
    const [showNotifications, setShowNotifications] = useState(false);
    const [showSettings, setShowSettings] = useState(false);
    const [lastReadTime, setLastReadTime] = useState(
      localStorage.getItem("notifLastRead") || new Date(0).toISOString(),
    );

    useEffect(() => {
      notificationsRef.current = notifications;
    }, [notifications]);

    useEffect(() => {
      if (user && typeof window !== "undefined" && "Notification" in window) {
        const browserNotifsPref = localStorage.getItem("pref_browser_notifications") !== "false";
        if (browserNotifsPref && Notification.permission === "default") {
          Notification.requestPermission();
        }
      }
    }, [user]);

    // Debounced Search Logic
    useEffect(() => {
      if (!searchQuery.trim()) {
        if (currentView === "listings") {
          // Optionally clear results if query is empty
          // onSearch("");
        }
        return;
      }

      const handler = setTimeout(() => {
        if (onSearch) onSearch(searchQuery);
      }, 500); // 500ms debounce

      return () => clearTimeout(handler);
    }, [searchQuery, onSearch, currentView]);

    useEffect(() => {
      if (user) {
        fetchNotifications(user.username || user.User_Name).then((data) => {
          setNotifications(data);
        });

        const interval = setInterval(() => {
          fetchNotifications(user.username || user.User_Name).then((data) => {
            const previous = notificationsRef.current;
            
            // Find new unread notifications that were not in the previous list
            const newUnreads = data.filter((n) => {
              const isUnread = n.isRead === false || n.IsRead === false;
              if (!isUnread) return false;
              return !previous.some(
                (old) => (old.id || old._id) === (n.id || n._id) || old.timestamp === n.timestamp
              );
            });

            if (newUnreads.length > 0) {
              playSound("NOTIFICATION");

              const browserNotifsPref = localStorage.getItem("pref_browser_notifications") !== "false";
              if (browserNotifsPref && typeof window !== "undefined" && "Notification" in window && Notification.permission === "granted") {
                newUnreads.forEach((notif) => {
                  const title = notif.user || "Pondy Connect";
                  let body = notif.title || "New notification";
                  if (body.startsWith(title)) {
                    body = body.substring(title.length).trim();
                  }

                  try {
                    const systemNotif = new Notification(title, {
                      body: body,
                      icon: "/logo192.png",
                      tag: notif.timestamp || notif.id,
                    });
                    systemNotif.onclick = () => {
                      window.focus();
                      setShowNotifications(true);
                      systemNotif.close();
                    };
                  } catch (err) {
                    console.error("Failed to trigger browser notification:", err);
                  }
                });
              }
            }
            setNotifications(data);
          });
        }, 20000);

        return () => clearInterval(interval);
      } else {
        setNotifications([]);
      }
    }, [user]);

    const unreadCount = notifications.filter(
      (n) => n.isRead === false || n.IsRead === false,
    ).length;

    const navItems = [
      { id: "connect", icon: (active) => <HomeIcon active={active} />, label: "Home" },
      { id: "market-square", icon: (active) => <DiscoverIcon active={active} />, label: "Discover" },
      { id: "real-estate", icon: (active) => <PropertyIcon active={active} />, label: "Property" },
      { id: "slotify", icon: (active) => <SlotifyIcon active={active} />, label: "Appointment" },
    ];

    const handleSearchClick = () => {
      if (searchQuery.trim() && onSearch) {
        onSearch(searchQuery);
      }
    };

    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        handleSearchClick();
      }
    };

    const timeAgo = (dateStr) => {
      let parseableDate = dateStr;
      if (typeof dateStr === "string" && dateStr.includes(" GMT")) {
        parseableDate = dateStr.replace(" GMT", "");
      }

      const date = new Date(parseableDate);
      const now = new Date();
      const seconds = Math.floor((now - date) / 1000);

      if (seconds < 60) return "Just now";
      const minutes = Math.floor(seconds / 60);
      if (minutes < 60) return `${minutes} mins ago`;
      const hours = Math.floor(minutes / 60);
      if (hours < 24) return `${hours} hrs ago`;
      const days = Math.floor(hours / 24);
      if (days < 7) return `${days} days ago`;
      return date.toLocaleDateString();
    };

    const getImageSrc = (img) => {
      if (!img) return "https://via.placeholder.com/56";
      if (img.startsWith("http") || img.startsWith("data:")) return img;
      if (img.startsWith("/uploads/")) return img;
      if (img.startsWith("uploads/")) return `/${img}`;
      return img;
    };

    const markAllAsRead = async () => {
      const now = new Date().toISOString();
      setLastReadTime(now);
      localStorage.setItem("notifLastRead", now);

      try {
        if (user) {
          await fetch(`${API_BASE_URL}/notifications/read`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ username: user.username || user.User_Name }),
          });
        }
      } catch (e) {
        console.error("Error marking as read:", e);
      }
    };

    const getNotifCategory = (type) => {
      switch (type) {
        case "ad":
          return "My Ads";
        case "follow":
          return "Followers";
        case "post":
        case "like":
        case "comment":
          return "Connect Wall";
        case "system_post":
          return "Updates";
        default:
          return "System";
      }
    };

    const formatNotifTitle = (title, user) => {
      if (!title) return "";
      let clean = title.replace(/^Notification\s+/i, "");
      if (user && user !== "Notification") {
        const userNameForRegex = user.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        clean = clean.replace(
          new RegExp(`^${userNameForRegex}:?\\s*`, "i"),
          "",
        );
      } else {
        clean = clean.replace(
          /^[A-Za-z\s]+(?=\s+(started following|liked|commented))/i,
          "",
        );
      }
      clean = clean.replace(
        /^(posted|shared)\s+a\s+new\s+(ad|update|item|status):?\s*/i,
        "$1 a new $2: ",
      );
      clean = clean.replace(/\s+on\s+your\s+post$/i, "");
      return clean.trim();
    };

    const getNotifIconOverlay = (type) => {
      switch (type) {
        case "like":
          return "❤️";
        case "comment":
          return "💬";
        case "follow":
          return "👤";
        case "ad":
          return "🏷️";
        default:
          return "🔔";
      }
    };

    const toggleSettings = () => {
      setShowNotifications(false);
      setShowSettings(!showSettings);
    };

    const handleNotificationsClick = (e) => {
      e.stopPropagation();
      setShowSettings(false);
      onNavigate("notifications");
    };

    return (
      <div className="header">
        <div className="header__left">
          <div
            className="header__logo"
            onClick={() => onNavigate && onNavigate("connect")}
          >
            <h1 className="logo-script">Pondy Connect</h1>
          </div>
        </div>

        <div className="header__center">
          <div className="header__centralNav">
            {navItems.map((item) => (
              <button
                key={item.id}
                className={`header__navItem ${item.id} ${currentView === item.id ? "active" : ""}`}
                onClick={() => onNavigate && onNavigate(item.id)}
              >
                <div className="nav-icon-wrapper">
                  {item.icon(currentView === item.id)}
                </div>
                <span>{item.label}</span>
              </button>
            ))}
          </div>
        </div>

        <div
          className={`header__navRight ${mobileMenuOpen ? "mobile-show" : ""}`}
        >
          <button
            className="header__boosterBtn hide-on-mobile"
            onClick={() => onNavigate("booster")}
          >
            <RocketIcon /> BOOSTER
          </button>

          <div className="header__systemIcons">
            <button
              className={`system-icon-btn ${currentView === "favourites" ? "active" : ""}`}
              onClick={() => onNavigate("favourites")}
              data-tooltip="Favourites"
            >
              <HeartIcon active={currentView === "favourites"} />
            </button>
            <button
              className={`system-icon-btn ${currentView === "notifications" ? "active" : ""}`}
              onClick={handleNotificationsClick}
              data-tooltip="Notifications"
            >
              <BellIcon active={currentView === "notifications"} />
              {currentView !== "notifications" && unreadCount > 0 && (
                  <span className="notif-badge-red">
                  {unreadCount > 9 ? "9+" : unreadCount}
                  </span>
              )}
            </button>
            <button
              className={`system-icon-btn ${['settings', 'about', 'business', 'guide', 'privacy', 'terms', 'safety', 'blocked', 'following', 'events', 'profile', 'download'].includes(currentView) ? "active" : ""}`}
              onClick={() => onNavigate("settings")}
              data-tooltip="Settings"
            >
              <CogIcon active={['settings', 'about', 'business', 'guide', 'privacy', 'terms', 'safety', 'blocked', 'following', 'events', 'profile', 'download'].includes(currentView)} />
            </button>
          </div>
        </div>

        {showWalletModal && (
          <WalletModal
            user={user}
            onClose={() => setShowWalletModal(false)}
            balance={user?.WalletBalance || 0}
          />
        )}
      </div>
    );
  },
);

export default Header;
